<template>
  <div class="input__w">
    <div class="input">
      <textarea
        v-model.trim="inputValue"
        class="input__field"
        rows="4"
        :name="name"
        :class="[
          { filled: inputValue },
          { error: undefined !== errors || customError },
        ]"
        @blur="onBlur"
        @input="onInput"
        @change="onChange"
      />
      <span class="input__caption" :class="{ required }">
        {{ _T(caption) }}
      </span>
      <div
        v-show="undefined !== errors || customError"
        class="input__error-img"
      >
        <img src="~~/assets/icons/error-input.svg" alt="error attention" />
      </div>
    </div>
    <div
      v-show="undefined !== errors || customError"
      class="input__error-caption-w"
    >
      <p v-if="null !== customError" class="input__error-caption">
        {{ customError }}
      </p>
      <p v-else class="input__error-caption">
        <template v-for="error in errors">
          {{ error }}
        </template>
      </p>
    </div>
  </div>
</template>

<script setup>
import { useDebounceFn } from "@vueuse/core";
import { FORM_INJECTION_KEY } from "~/nuxt_modules/common/constants/index.js";

const props = defineProps({
  name: { type: String, required: true },
  caption: { type: String, required: true },
  customError: { required: false, default: null },
  required: { type: Boolean, required: false, default: true },
});

const inputValue = defineModel({
  set(value) {
    if (0 !== value.length) {
      return value;
    }
  },
});

/*
Получаем набор ошибок с формы и достаем их по ключу(name) инпута.
validateField - для запуска валидации текущего инпута
 */
const { errors: formErrors, validateField } = inject(FORM_INJECTION_KEY);
const errors = computed(() => {
  return formErrors?.value[props.name];
});

function onBlur() {
  validateField(props.name);
}

function onChange() {
  validateField(props.name);
}

const onInput = useDebounceFn(() => {
  validateField(props.name);
}, 300);
</script>

<style lang="scss" scoped>
.input__caption {
  left: 16px;
  top: 18px;
}

.input__field {
  resize: none;
}

.input {
  border-radius: 16px;
}
</style>
